import { render, staticRenderFns } from "./DefStdRiskTxt.vue?vue&type=template&id=17f40ebf&"
import script from "./DefStdRiskTxt.vue?vue&type=script&lang=js&"
export * from "./DefStdRiskTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports